import { motion } from "framer-motion";

type AnimatedKPIProps = {
  title: string;
  value: number | null | undefined;
};
const AnimatedKPI = ({ title, value }: AnimatedKPIProps) => {
  const safeValue = Number(value ?? 0) || 0;
  return (
    <div>
      <motion.p
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.2 }}
        className="text-shopify-body text-shopify-medium mb-2 uppercase tracking-wide"
      >
        {title}
      </motion.p>

      <motion.h2
        initial={{ opacity: 0, scale: 0.6 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.3, type: "spring", stiffness: 200 }}
        className="text-shopify-metric text-shopify-dark"
      >
        USD$ {safeValue.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
      </motion.h2>
    </div>
  );
};

export default AnimatedKPI;
